import { apiService } from "../../app.service";

export const locationApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ Get all locations
    getLocations: builder.query({
      query: () => ({
        url: "/locations",
      }),
      providesTags: ["Locations"],
    }),

    // ✅ Get single location
    getLocationById: builder.query({
      query: (id) => ({
        url: `/locations/${id}`,
      }),
      providesTags: (result, error, id) => [{ type: "Location", id }],
    }),

    // ✅ Update location
    updateLocation: builder.mutation({
      query: ({ id, data }) => ({
        url: `/locations/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Location", id },
        "Locations",
      ],
    }),

    // ✅ Delete location
    deleteLocation: builder.mutation({
      query: (id) => ({
        url: `/locations/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Locations"],
    }),

    // ✅ Switch location
    switchLocation: builder.mutation({
      query: (data) => ({
        url: "/locations/switch",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Locations", "Restaurant"],
    }),

    // ✅ Update location settings
    updateLocationSettings: builder.mutation({
      query: ({ id, data }) => ({
        url: `/locations/${id}/settings`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Location", id },
        "Locations",
      ],
    }),

    suspendLocation: builder.mutation({
      query: (id) => ({
        url: `/restaurant/location/${id}/suspend`,
        method: "POST",
      }),
      invalidatesTags: ["Locations", "Restaurant"],
    }),

    unsuspendLocation: builder.mutation({
      query: (id) => ({
        url: `/restaurant/location/${id}/unsuspend`,
        method: "POST",
      }),
      invalidatesTags: ["Locations", "Restaurant"],
    }),

    getLocationsSummary: builder.query({
      query: () => ({
        url: "/restaurant/locations-summary",
      }),
      providesTags: ["Locations"],
    }),

    getTemperatureAlerts: builder.query({
      query: () => ({
        url: "/restaurant/temperature-alerts",
      }),
      providesTags: ["Locations"],
    }),
  }),
});

export const {
  useGetLocationsQuery,
  useGetLocationByIdQuery,
  useUpdateLocationMutation,
  useDeleteLocationMutation,
  useSwitchLocationMutation,
  useUpdateLocationSettingsMutation,
  useSuspendLocationMutation,
  useUnsuspendLocationMutation,
  useGetLocationsSummaryQuery,
  useGetTemperatureAlertsQuery,
} = locationApi;